import { useSearch } from "@tanstack/react-router";

import { OrganizationMembers } from "./organization-members";
import { OrganizationProfile } from "./organization-profile";

export function OrganizationSettingsPage() {
  const searchParams = useSearch({ strict: false });
  const section =
    typeof searchParams === "object" &&
    searchParams !== null &&
    "section" in searchParams &&
    typeof searchParams.section === "string"
      ? searchParams.section
      : undefined;
  const isMembersPage = section === "members";

  return (
    <>
      <div className="mb-4">
        <h1 className="h2 font-heading text-foreground text-balance">
          {isMembersPage ? "Members" : "Organization"}
        </h1>
        <p className="text-muted-foreground">
          {isMembersPage
            ? "Manage organization members and their roles"
            : "Manage your organization settings and information"}
        </p>
      </div>

      <div className="space-y-6">
        {isMembersPage ? <OrganizationMembers /> : <OrganizationProfile />}
      </div>
    </>
  );
}
